import AthleteTableInfoCard from "../AthleteTable/AthleteTableInfoCard";
import MuiThemeProvider from "components/MuiThemeProvider";
import PageInfoCardAdornment from "components/Layout/PageInfoCardAdornment";
import { useTranslation } from "react-i18next";
import Constants from "config/Constants";

function AthleteTableInfoCardAdornment() {
  const { t } = useTranslation();

  return (
    <PageInfoCardAdornment pageTitle={t(Constants.routes.athletes.titleKey)}>
      {(props) => (
        <MuiThemeProvider>
          <AthleteTableInfoCard onClose={props.onClose} />
        </MuiThemeProvider>
      )}
    </PageInfoCardAdornment>
  );
}

export default AthleteTableInfoCardAdornment;
